export default {
  title: 'Betalingsgateway',
  description:
    'Dine egne betalingsgateways til onlinebestillinger. Hele ordrebeløbet afregnes til din gatewaykonto, og du afregner selv med dine restauranter.',
  toasts: {
    load_error: 'Gateway-opsætningen kunne ikke indlæses',
  },
  not_enabled: {
    title: 'Spreedly er endnu ikke aktiveret på din konto',
    description:
      'Lokale betalingsgateways aktiveres af FoodAmigos. Kontakt din FoodAmigos-repræsentant for at komme i gang.',
  },
  processor_mode: {
    title: 'Hvem behandler betalingerne?',
    description:
      'Dette indstilles én gang for alle dine restauranter. Du kan skifte senere i Partnerindstillinger, så længe ingen restaurant er live.',
    save: 'Gem',
    options: {
      platform: {
        title: 'FoodAmigos behandler betalinger',
        badge: 'Anbefalet',
        description:
          'Vi håndterer betalingskontoen, verificeringen og udbetalingerne. Hver restaurant tilføjer sine virksomhedsoplysninger og gennemfører et kort tjek hos Adyen.',
        methods: 'Accepteret: {{methods}}',
      },
      provider: {
        title: 'Jeg bruger min egen udbyder',
        description:
          'Tilslut en betalingsudbyder, du allerede bruger. Udbetalinger, gebyrer og verificering forbliver hos dem.',
      },
    },
    payment_methods: {
      card: 'Kort',
      apple_pay: 'Apple Pay',
      google_pay: 'Google Pay',
      pay_by_bank: 'Betal via bank',
      giropay: 'giropay',
      sepa_debit: 'SEPA',
    },
    locked: {
      platform: 'FoodAmigos behandler betalinger for alle dine restauranter.',
      provider: 'Dine restauranter modtager betalinger via dine egne udbydere.',
    },
    confirm_choice: {
      title: 'Indstille betalinger til «{{mode}}»?',
      description:
        'Dette gælder for alle restauranter, du driver. Du kan skifte senere i Partnerindstillinger, men kun så længe ingen restaurant er live.',
      confirm: 'Gem og fortsæt',
    },
    switch: {
      link: 'Skift, hvordan betalinger behandles',
      confirm: {
        confirm: 'Skift',
        provider: {
          title: 'Skifte til din egen udbyder?',
          description: 'Restauranter, der bruger FoodAmigos-betalinger, vender tilbage til Ikke opsat.',
        },
        platform: {
          title: 'Skifte til FoodAmigos-betalinger?',
          description: 'Restauranter, der bruger dine egne udbydere, vender tilbage til Ikke opsat.',
        },
      },
      unavailable: {
        title: 'FoodAmigos-betalinger er endnu ikke tilgængelige',
        description: 'FoodAmigos-betalinger er endnu ikke tilgængelige i dit land.',
        confirm: 'OK',
      },
      blocked: {
        title: 'Kontakt FoodAmigos for at ændre dette',
        description_one:
          '{{count}} restaurant modtager live-betalinger. Et skift vil betyde, at den skal onboardes igen hos den nye udbyder. Vores team planlægger det sammen med dig.',
        description_other:
          '{{count}} restauranter modtager live-betalinger. Et skift vil betyde, at de skal onboardes igen hos den nye udbyder. Vores team planlægger det sammen med dig.',
        confirm: 'Skriv til FoodAmigos',
        subject_one: 'Skift, hvordan betalinger behandles ({{count}} live restaurant)',
        subject_other: 'Skift, hvordan betalinger behandles ({{count}} live restauranter)',
      },
    },
    toasts: {
      load_error: 'Betalingsopsætningen kunne ikke indlæses',
      save_error: 'Betalingsopsætningen kunne ikke gemmes',
      chosen: 'Betalingsbehandling gemt',
      switched: 'Betalingsbehandling skiftet',
    },
  },
  gateways: {
    title: 'Tilsluttede udbydere',
    empty: 'Tilslut den betalingsudbyder, du allerede bruger. Dine restauranter bliver onboardet under den.',
    connect_another: 'Tilslut en udbyder',
    support_hint:
      'Når en restaurant modtager live-betalinger, planlægges et skift af udbyder sammen med os – skriv til {{email}}.',
    kinds: {
      stripe_connect: 'Stripe Connect',
      spreedly: 'Betalingsgateway',
      platform_adyen: 'FoodAmigos-betalinger',
    },
    statuses: {
      connected: 'Tilsluttet',
      disconnected: 'Afbrudt',
      needs_attention: 'Kræver opmærksomhed',
    },
    issue: {
      connect_not_enabled: {
        title: 'Stripe Connect er ikke aktiveret på kontoen bag {{name}}',
        description:
          'Stripe kan ikke oprette konti til dine restauranter, før Connect er aktiveret. Aktivér det i dit Stripe-dashboard, og tjek derefter igen her.',
      },
      account_restricted: {
        title: 'Stripe tilbageholder nye konti under {{name}}',
        description:
          'Stripe har midlertidigt begrænset din konto i at oprette tilknyttede konti. Log ind på dit Stripe-dashboard, bekræft, at du havde til hensigt at oprette disse konti, og tjek derefter igen her.',
      },
      loss_liability_unaccepted: {
        title: 'Stripe kræver, at {{name}} først accepterer ansvar for tab',
        description:
          'Din Stripe-platform har endnu ikke accepteret ansvaret for negative saldi på dine restauranters konti, så Stripe opretter dem ikke. Åbn Indstillinger → Connect → Platformprofil i dit Stripe-dashboard, og gennemfør bekræftelsen af tabsansvar. Tjek derefter igen her. Du kan se bort fra Stripes note om Accounts v2 nedenfor.',
      },
      account_creation_refused: {
        title: 'Stripe afviste at oprette en restaurantkonto under {{name}}',
        description: 'Gennemgå beskeden nedenfor i dit Stripe-dashboard, og tjek derefter igen her.',
      },
      key_invalid: {
        title: 'Stripe accepterer ikke længere den nøgle, du har forbundet for {{name}}',
        description:
          'Nøglen er blevet rullet, tilbagekaldt eller er udløbet. Opret en ny nøgle i dit Stripe Dashboard, og erstat den derefter her.',
      },
      key_access_limited: {
        title: 'Stripe har begrænset den nøgle, du har forbundet for {{name}}',
        description:
          'En begrænset nøgle kan ikke oprette overførsler eller udbetalinger til dine restauranter. Åbn Developers → API keys i dit Stripe Dashboard, og gendan nøglens fulde adgang, og kontrollér derefter igen her – eller roter nøglen og erstat den her.',
      },
      provider_said: 'Hvad Stripe sagde: «{{message}}»',
      hint: 'Indtil dette er løst, kan restauranter, der er knyttet til denne udbyder, ikke begynde at modtage onlinebetalinger.',
      open_stripe: 'Åbn Stripe-dashboard',
      check_again: 'Tjek igen',
      replace_key: 'Udskift nøgle',
      cleared: 'Stripe accepterer nu dine restauranter igen',
      still_blocked: 'Stripe afviser stadig – se, hvad der blev sagt ovenfor',
    },
    refused: {
      provider_said: 'Hvad {{name}} sagde: “{{message}}”',
      reference: 'Reference:',
      contact_support: 'Send support en e-mail',
      support_subject: 'Tilslutning af betalingsudbyder afvist: {{name}} (ref {{reference}})',
      account_in_test_mode: {
        action: 'Slå Testtilstand fra i Authorize.Net, under {{path}}, og prøv igen.',
        open: 'Åbn Authorize.Net',
      },
      processor_not_configured: {
        action:
          'Kontakt din merchant service provider, virksomheden der oprettede din Authorize.Net-konto, og bed dem om at færdiggøre opsætningen med betalingsprocessoren. Nye nøgler vil ikke ændre dette. Prøv derefter igen.',
        action_card_connect:
          'Bed CardConnect-support om at aktivere card-not-present-autorisationer (e-handel) på dette forhandler-id. Nye API-legitimationsoplysninger ændrer ikke på dette. Prøv derefter igen.',
      },
    },
    table: {
      primary_tag: 'Standard',
      live_count_one: '{{count}} modtager betalinger',
      live_count_other: '{{count}} modtager betalinger',
      attention_count_one: '{{count}} kræver opmærksomhed',
      attention_count_other: '{{count}} kræver opmærksomhed',
      columns: {
        connection: 'Udbyder',
        status: 'Status',
        restaurants: 'Restauranter',
        methods: 'Lokale betalingsmetoder',
      },
      methods_count: '{{enabled}} af {{capable}} aktiveret',
    },
    picker: {
      recommended: 'Anbefalet',
      connect: 'Tilslut',
      stripe_connect: {
        title: 'Stripe Connect',
        description:
          'Brug din egen Stripe-konto. Hver restaurant gennemfører Stripes egen onboarding; udbetalinger og gebyrer forbliver hos Stripe.',
        already_connected:
          'Allerede tilsluttet. Brug Rediger legitimationsoplysninger på listen for at udskifte nøglen.',
        already_connected_short: 'Allerede tilsluttet.',
      },
      stripe_direct: {
        title: 'Stripe (direkte)',
        description: 'Opkræv betaling fra alle restauranter via én af dine Stripe-konti.',
        unavailable: 'Endnu ikke tilgængelig i din region.',
      },
      paypal: {
        direct: 'Tilbyd PayPal fra din egen PayPal-forretningskonto.',
        braintree: 'Modtag kort, PayPal og Venmo via din Braintree-konto.',
      },
      other: {
        title: 'Andre udbydere',
        search: 'Søg efter udbydere',
        loading: 'Indlæser udbydere…',
        no_match: 'Ingen udbyder med navnet «{{query}}».',
        none_available: 'Der er endnu ingen andre udbydere tilgængelige i din region.',
        load_error: 'Listen over udbydere kunne ikke indlæses.',
        retry: 'Prøv igen',
        pinned_match: 'Den udbyder er fastgjort ovenfor.',
      },
      not_listed: {
        action: 'Min udbyder er der ikke',
        subject: 'Anmodning om betalingsudbyder: {{query}}',
      },
      use_foodamigos: {
        no_account: 'Jeg har ikke en konto hos nogen af disse',
        switch: 'Skift til FoodAmigos-betalinger',
      },
    },
    orchestrated: {
      title: 'Tilslut {{name}}',
      replace_title: 'Udskift loginoplysningerne for {{name}}',
      intro: 'Indtast loginoplysningerne fra din {{name}}-konto. Vi tjekker dem hos {{name}}, før noget gemmes.',
      auth_mode: 'Sådan logger du ind hos denne udbyder',
      checking: 'Tjekker hos {{name}}…',
      paypal_direct: {
        intro:
          'Indsæt Client ID og Secret for den PayPal REST-app, som dine restauranter skal modtage PayPal-betalinger igennem. Vi tjekker dem hos PayPal, før noget gemmes.',
        client_id: 'Client ID',
        secret: 'Secret',
        hint: 'PayPal Developer Dashboard → Apps & Credentials, under fanen Live. Brug en REST-app fra din erhvervskonto.',
        hint_sandbox:
          'PayPal Developer Dashboard → Apps & Credentials, under fanen Sandbox: dette miljø accepterer kun sandbox-apps.',
      },
      braintree: {
        intro:
          'Indtast API-nøglerne til din Braintree-konto. PayPal og Venmo virker, når de er koblet til i dit Braintree Control Panel – bagefter slår du dem til for hver forbindelse.',
      },
      authorize_net: {
        intro:
          'Indtast API Login ID og Transaction Key for din Authorize.Net-konto. Vi kontrollerer dem med en lille testautorisation: din Authorize.Net-transaktionslog viser den som en afvist betaling på $1,00, og der flyttes ingen penge. Kontoen skal være i Live-tilstand, da Authorize.Net i Testtilstand afviser alle rigtige betalinger.',
        hint: 'Du finder begge i Authorize.Net Merchant Interface, under {{path}}.',
      },
      card_connect: {
        intro:
          'Indtast forhandler-id, brugernavn og adgangskode til din live CardConnect-konto (CardPointe). Vi kontrollerer dem med en autorisation på 1,00, som vi annullerer med det samme: din CardPointe-transaktionslog viser den som en afvist eller annulleret 1,00, og der flyttes ingen penge.',
      },
      stripe_direct: {
        intro:
          'Indsæt den hemmelige nøgle eller en begrænset nøgle fra den Stripe-konto, som alle restauranter skal opkræve betaling via. Vi opsætter den webhook, Stripe har brug for, for dig.',
        secret_key: 'Stripe hemmelig eller begrænset nøgle',
        hint: 'Stripe → Developers → API keys. Begynder med sk_ (hemmelig) eller rk_ (begrænset). En begrænset nøgle kræver skriveadgang til Charges and Refunds, Customers, PaymentIntents, PaymentMethods, SetupIntents, Tokens og Webhook Endpoints. Der er ikke brug for en publishable key.',
        prefix_error: 'Stripes hemmelige nøgler begynder med sk_, begrænsede nøgler med rk_.',
      },
      connected: {
        title: '{{name}} er tilsluttet.',
        description:
          'Vi bruger disse loginoplysninger til alle dine restauranter. Hver restaurant tilføjer stadig sine egne virksomhedsoplysninger.',
      },
      errors: {
        generic: 'Vi kunne ikke tilslutte {{name}}',
      },
    },
    stripe: {
      title: 'Tilslut Stripe Connect',
      rotate_title: 'Udskift din Stripe Connect-nøgle',
      rotate_intro:
        'Indsæt en ny hemmelig nøgle og publicerbar nøgle fra den samme Stripe-konto. Dine restauranter forbliver tilsluttet.',
      intro:
        'Indsæt den hemmelige nøgle og den publicerbare nøgle til din Stripe-konto. Begge findes under Developers → API keys.',
      verify_and_connect: 'Bekræft og tilslut',
      checking: 'Tjekker hos Stripe…',
      secret_key: {
        label: 'Hemmelig nøgle',
        hint: 'Stripe → Developers → API keys. Begynder med sk_.',
        prefix_error: 'Hemmelige nøgler begynder med sk_. Det her ligner en anden type nøgle.',
      },
      restricted_key: {
        label: 'Begrænset API-nøgle',
        hint: 'Stripe → Developers → API keys → Create restricted key. Begynder med rk_. Opsæt den som beskrevet ovenfor.',
        prefix_error: 'Begrænsede nøgler begynder med rk_. Det her ligner en anden type nøgle.',
      },
      use_restricted_key: 'Brug en begrænset nøgle i stedet',
      use_secret_key: 'Brug den hemmelige nøgle i stedet',
      publishable_key: {
        label: 'Publicerbar nøgle',
        hint: 'På den samme Stripe-side. Begynder med pk_. Dine webshops skal bruge den for at kunne acceptere kort.',
        prefix_error: 'Publicerbare nøgler begynder med pk_.',
        mode_mismatch:
          'Den ene nøgle er live, og den anden er en testnøgle. Begge skal komme fra samme Stripe-tilstand.',
      },
      name: {
        label: 'Navngiv denne forbindelse',
        hint: 'Valgfrit. Vises overalt, hvor denne udbyder er opført.',
        placeholder: 'Stripe Connect',
      },
      permissions: {
        title: 'Sådan opretter du denne nøgle',
        start_blank:
          'Når Stripe spørger, hvordan du vil bruge nøglen, skal du vælge “{{option}}”. Den starter med, at alle tilladelser er sat til {{none}}.',
        intro:
          'Indstil derefter kontakten på hver af disse sektionsrækker. Den indstiller alle tilladelser i den sektion, så du ikke behøver at gennemgå dem enkeltvis.',
        rows_checked: 'Vi kontrollerer: {{rows}}',
        secret_key_hint:
          'Lad alle andre sektioner stå på {{none}}. En hemmelig nøgle har ikke brug for noget af dette.',
        open_stripe: 'Åbn dine Stripe API-nøgler',
      },
      login_setting: {
        title: 'Slå Stripes login fra for dine restauranter',
        description:
          'Åbn Indstillinger → Connect → Udbetalinger → Eksterne konti i dit Stripe Dashboard, og slå “{{setting}}” fra. Så længe den er slået til, får hver restaurant under onboarding oprettet et Stripe-login med et telefonnummer og bliver bedt om en SMS-kode ved hvert senere besøg, så de, der ikke har telefonen ved hånden, ikke kan komme videre.',
        bank_details: 'Intet går tabt: Restauranterne indtaster deres bankoplysninger i vores egen formular.',
        open_stripe: 'Åbn denne Stripe-indstilling',
      },
      errors: {
        generic: 'Stripe kunne ikke nås',
      },
    },
    default_choice: {
      label: 'Brug som standard for restauranter',
      hint: 'Nye restauranter og restauranter uden udbyder bliver automatisk knyttet til den. Lad feltet være umarkeret, hvis du selv vil vælge en udbyder for hver restaurant.',
    },
    manage: {
      payment_methods: 'Betalingsmetoder',
      edit_credentials: 'Rediger loginoplysninger',
      edit_credentials_unavailable: 'Rediger loginoplysninger (denne udbyder tilbydes ikke lige nu)',
      set_primary: 'Angiv som standard for nye restauranter',
      clear_primary: 'Brug ikke længere som standard til nye restauranter',
      rename: {
        action: 'Omdøb forbindelse',
        title: 'Omdøb denne forbindelse',
        confirm: 'Gem',
      },
      disconnect: {
        action: 'Afbryd',
        title: 'Afbryd {{name}}?',
        confirm: 'Afbryd',
        warning_one: '{{count}} restaurant er knyttet til den og vender tilbage til Ikke opsat.',
        warning_other: '{{count}} restauranter er knyttet til den og vender tilbage til Ikke opsat.',
        live: {
          title_one: 'Onlinebetalinger sættes på pause for {{count}} aktiv restaurant',
          title_other: 'Onlinebetalinger sættes på pause for {{count}} aktive restauranter',
          description:
            'Så snart du afbryder forbindelsen, kan deres kunder ikke længere betale online. Hver restaurant går tilbage til Ikke konfigureret, indtil du knytter den til en anden udbyder.',
          refunds: 'Ordrer, der allerede er betalt via denne udbyder, kan ikke længere refunderes fra FoodAmigos.',
          pause_one: 'Sæt onlinebetalinger på pause for denne restaurant',
          pause_other: 'Sæt onlinebetalinger på pause for disse {{count}} restauranter',
          confirm: 'Afbryd og sæt betalinger på pause',
        },
      },
      remove: {
        action: 'Fjern fra listen',
        title: 'Fjern {{name}}?',
        description:
          'Den er allerede frakoblet, og ingen restaurant bruger den. Den vises ikke længere på denne liste.',
        confirm: 'Fjern',
      },
    },
    payment_methods: {
      title: 'Betalingsmetoder for {{name}}',
      description:
        'Vælg de lokale metoder, dine restauranter tilbyder via denne udbyder. Hver metode vises kun, hvor restaurantens valuta passer.',
      save: 'Gem',
      publishable_key: {
        label: 'Stripe publicerbar nøgle',
        hint: 'Stripe skal bruge den for at vise betalingsformularen. Du finder den i dit Stripe Dashboard under Developers → API keys.',
        invalid: 'En publicerbar nøgle her begynder med {{prefix}}.',
        clear_to_save:
          'Den tilhører Stripes anden tilstand. Ryd feltet for at gemme med alle lokale metoder slået fra.',
      },
      on_other_connection: 'allerede slået til for {{connection}}',
      other_currency: 'tilbydes ikke i {{currency}}',
      delivery_only: '{{name}} (kun leveringsordrer – den kræver kundens adresse)',
      invite_only:
        '{{name}} (Stripe tilbyder den kun efter invitation – anmod om adgang i dit Stripe-dashboard først, ellers afviser Stripe alle betalinger)',
      also_enable: {
        stripe:
          'Slå de samme metoder til i dit Stripe Dashboard under Settings → Payment methods, ellers afviser Stripe dem.',
        provider: 'Din kontrakt med denne udbyder skal omfatte de metoder, du slår til her.',
        braintree:
          'Kobl først PayPal og Venmo til i dit Braintree Control Panel under Settings → Processing, ellers afviser Braintree dem. Venmo er til restauranter i USA, der opkræver i dollar.',
        paypal_direct:
          'PayPal-betalinger indbetales på denne PayPal-erhvervskonto. For Venmo skal du tilslutte Braintree.',
      },
    },
    actions: {
      cancel: 'Annuller',
    },
    toasts: {
      load_error: 'Dine tilsluttede udbydere kunne ikke indlæses',
      credentials_replaced: 'Loginoplysninger udskiftet',
      save_error: 'Kunne ikke gemme',
      connected: 'Stripe Connect er tilsluttet',
      renamed: 'Forbindelsen er omdøbt',
      primary_set: 'Standardudbyder opdateret',
      primary_cleared: 'Standardudbyder fjernet. Nye restauranter knyttes ikke til en udbyder, før du vælger en.',
      disconnected: 'Udbyder afbrudt',
      removed: 'Udbyder fjernet',
      payment_methods_saved: 'Betalingsmetoder gemt',
    },
  },
  restaurants: {
    title: 'Restauranter',
    description: 'Hvor hver restaurant står med hensyn til onlinebetalinger.',
    search: 'Søg efter restauranter',
    filters: {
      all: 'Alle ({{count}})',
      needs_attention: 'Kræver opmærksomhed ({{count}})',
    },
    empty: 'Ingen restauranter endnu.',
    empty_attention: 'Intet kræver din opmærksomhed.',
    columns: {
      restaurant: 'Restaurant',
      provider: 'Udbyder',
      status: 'Status',
      action: 'Handling',
    },
    no_provider: '—',
    foodamigos_payments: 'FoodAmigos-betalinger',
    groups: {
      not_set_up: 'Ikke opsat',
      business_details_missing: 'Virksomhedsoplysninger mangler',
      hosted_not_finished: '{{provider}}-formularen er ikke udfyldt',
      hosted_not_finished_generic: 'Udbyderens formular er ikke udfyldt',
      waiting_for_provider: 'Venter på udbyder',
      action_needed: 'Handling påkrævet',
      payments_live: 'Betalinger er live',
      online_payments_off: 'Onlinebetalinger er slået fra',
      waiting_for_partner: 'Venter på dig',
    },
    link_expired: 'Linket er udløbet',
    actions: {
      set_up: 'Opsæt',
      change: 'Skift',
      unlink: 'Fjern link',
      remind: 'Påmind ejer',
      reminded: 'Påmindet · igen {{time}}',
      start_over: 'Start Stripe-opsætning forfra',
    },
    assign: {
      title: 'Hvilken udbyder skal {{name}} bruge?',
      label: 'Udbyder',
      confirm: 'Gem',
      cancel: 'Annuller',
      primary: 'Standard',
      none: 'Tilslut først en udbyder.',
    },
    unlink: {
      title: 'Fjern {{name}} fra {{provider}}?',
      title_generic: 'Fjern tilknytningen mellem {{name}} og dens udbyder?',
      description:
        'Restauranten går tilbage til Ikke konfigureret, så du kan vælge den rette udbyder til den. Udbyderen forbliver tilsluttet til dine andre restauranter.',
      confirm: 'Fjern link',
    },
    pause: {
      title: 'Onlinebetalinger er sat på pause for {{name}}',
      description:
        'Kunderne kan ikke længere betale online, før restauranten er konfigureret og verificeret hos en udbyder igen.',
      refunds: 'Ordrer, der allerede er betalt via den nuværende udbyder, kan ikke længere refunderes fra FoodAmigos.',
      confirm: 'Sæt onlinebetalinger på pause for denne restaurant',
    },
    start_over: {
      title: 'Start Stripe-opsætningen af {{name}} forfra?',
      points: {
        not_used: 'Den nuværende Stripe-konto ({{account}}) vil ikke længere blive brugt til denne restaurant.',
        kept: 'Kontoen slettes ikke: Den forbliver i din Stripe, hvor du kan afvise den.',
        fresh:
          'Næste gang du klikker på „Fortsæt“, starter det forfra fra Stripes første side, og du kan bruge en anden e-mail.',
        paused:
          'Hvis restauranten tager imod onlinebetalinger, sættes de på pause, indtil den nye opsætning er færdig.',
      },
      confirm: 'Start forfra',
      blocked: {
        received_payments:
          'Denne restaurants Stripe-konto har modtaget betalinger, så opsætningen kan ikke startes forfra. Kontakt support for at ændre den.',
        partner_action_needed: 'Løs først problemet, der vises på din Stripe Connect.',
      },
    },
    toasts: {
      load_error: 'Dine restauranter kunne ikke indlæses',
      assigned: 'Udbyder gemt',
      assign_error: 'Udbyderen kunne ikke gemmes',
      unlinked: 'Restaurantens link er fjernet',
      unlink_error: 'Restaurantens link kunne ikke fjernes',
      reminded: 'Påmindelse sendt til ejeren',
      remind_error: 'Påmindelsen kunne ikke sendes',
      cooling_down: 'Ejeren er allerede blevet påmindet i dag',
      started_over: 'Stripe-opsætning startet forfra',
      start_over_error: 'Kunne ikke starte Stripe-opsætningen forfra',
    },
  },
  footer: {
    text: 'Dit FoodAmigos-servicegebyr faktureres til dig, uanset hvilken udbyder en restaurant bruger.',
    link: 'Se fakturering',
  },
};
